import React from 'react';
import { func } from 'prop-types';

import { FORM_SCHEMAS, validationSchema } from '../../utils';

import FormWrapper from '~components/FormWrapper';
import { companyPropTypes } from '~propTypes/company';
import { CURRENT_COUNTRY_ID } from '~constants/environment';
import { INITIAL_VALUES } from '~screens/Dashboard/components/ElectronicReceipt/constants';

import ElectronicReceiptFormLayout from './layout';

function ElectronicReceiptForm({ company, handleSaveCompany, handleDeleteCompany }) {
  const initialValues = company || INITIAL_VALUES;

  return (
    <FormWrapper
      initialValues={initialValues}
      onSubmit={handleSaveCompany}
      validationSchema={validationSchema(FORM_SCHEMAS[CURRENT_COUNTRY_ID])}>
      {({ isSubmitting, handleSubmit, handleBlur, values, setFieldValue, submitForm }) => (
        <ElectronicReceiptFormLayout
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
          handleBlur={handleBlur}
          values={values}
          setFieldValue={setFieldValue}
          submitForm={submitForm}
          handleDeleteAddress={handleDeleteCompany}
          company={company}
        />
      )}
    </FormWrapper>
  );
}

ElectronicReceiptForm.propTypes = {
  company: companyPropTypes,
  handleDeleteCompany: func,
  handleSaveCompany: func
};

export default ElectronicReceiptForm;
